import api from "./api";

export const track = (type, extra = {}) => {
  try {
    const p = new URLSearchParams(window.location.search);
    api.post("/events", {
      type, page: window.location.pathname,
      utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "", ...extra,
    }).catch(() => {});
  } catch { /* never block UI */ }
};

export const newIdempotencyKey = () =>
  (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

export const inrCompact = (n) => {
  if (!n) return "₹0";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(n % 10000000 ? 1 : 0)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(n % 100000 ? 1 : 0)} L`;
  return inr(n);
};

export const waLink = (settings, message) => {
  const num = (settings?.whatsapp || "").replace(/\D/g, "");
  const text = encodeURIComponent(message || settings?.whatsapp_templates?.default || "Hello BharatBest Fintech");
  return `https://wa.me/${num}?text=${text}`;
};

export const telLink = (settings) => `tel:${(settings?.phone || "").replace(/[^\d+]/g, "")}`;

export const LOAN_TYPES = [
  "Personal Loan", "Home Loan", "Business Loan", "Education Loan",
  "Vehicle Loan", "Loan Against Property", "Working Capital Loan", "Balance Transfer",
];

export const EMPLOYMENT_TYPES = ["Salaried", "Self-Employed"];

export const CIBIL_RANGES = ["750+ (Excellent)", "700–749 (Good)", "650–699 (Fair)", "Below 650", "No credit history"];

export const PIPELINE = [
  { key: "new", label: "New Lead" },
  { key: "contacted", label: "Contacted" },
  { key: "qualified", label: "Qualified" },
  { key: "documents_pending", label: "Documents Pending" },
  { key: "application_submitted", label: "Application Submitted" },
  { key: "under_review", label: "Under Review" },
  { key: "sanctioned", label: "Sanctioned" },
  { key: "disbursed", label: "Disbursed" },
  { key: "rejected", label: "Rejected" },
  { key: "lost", label: "Lost" },
];

export const STATUS_COLORS = {
  new: "bg-blue-50 text-blue-700 border-blue-200",
  contacted: "bg-amber-50 text-amber-700 border-amber-200",
  qualified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  documents_pending: "bg-orange-50 text-orange-700 border-orange-200",
  application_submitted: "bg-indigo-50 text-indigo-700 border-indigo-200",
  under_review: "bg-violet-50 text-violet-700 border-violet-200",
  sanctioned: "bg-green-50 text-green-700 border-green-200",
  disbursed: "bg-green-100 text-green-800 border-green-300",
  rejected: "bg-red-50 text-red-700 border-red-200",
  lost: "bg-gray-100 text-gray-600 border-gray-200",
};

export const statusLabel = (key) => PIPELINE.find((p) => p.key === key)?.label || key;

export const PRODUCT_ICONS = {
  Wallet: "Wallet", Home: "Home", Briefcase: "Briefcase", GraduationCap: "GraduationCap",
  Car: "Car", Building2: "Building2", TrendingUp: "TrendingUp", ArrowLeftRight: "ArrowLeftRight",
  Landmark: "Landmark", HandCoins: "HandCoins", PiggyBank: "PiggyBank", CreditCard: "CreditCard",
};
